"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["Banner"] = "banner";
    MessageType["Environment"] = "environment";
    MessageType["Miscellaneous"] = "misc";
    MessageType["Private"] = "private";
    MessageType["NPCChatter"] = "npcchat";
    MessageType["PlayerChat"] = "playerchat";
    MessageType["Lobby"] = "lobby";
    MessageType["Chatter"] = "chatter";
    MessageType["Other"] = "other";
    MessageType["Kill"] = "kill";
    MessageType["Hit"] = "hit";
    MessageType["Heal"] = "heal";
    MessageType["Description"] = "description";
    MessageType["NotMe"] = "notme";
    MessageType["Player"] = "player";
    MessageType["NPC"] = "npc";
    MessageType["Quest"] = "quest";
    MessageType["Muted"] = "muted";
    // combat subtypes
    MessageType["Combat"] = "combat";
    MessageType["Self"] = "self";
    MessageType["Miss"] = "miss";
    MessageType["Block"] = "block";
    MessageType["Blocked"] = "blocked";
    MessageType["Armor"] = "armor";
    MessageType["Weapon"] = "weapon";
    MessageType["Shield"] = "shield";
    MessageType["Offhand"] = "offhand";
    MessageType["OutOvertime"] = "out-overtime";
    MessageType["InOvertime"] = "in-overtime";
    MessageType["Melee"] = "melee";
    MessageType["Magic"] = "magic";
})(MessageType || (exports.MessageType = MessageType = {}));
